export const iconFontAwesomeUsersPeopleElevator = (
	<i className="fa-solid fa-elevator"></i>
);
